import React, { useState, useEffect } from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../components/ui/table';
import { CurrencyDollar } from '@phosphor-icons/react';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import api from '../services/api';

export function PortalPaymentsPage() {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await api.get('/portal/payments');
        setPayments(res.data.items || []);
      } catch {
        toast.error('Erreur de chargement');
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, []);

  const getStatutBadge = (statut) => {
    const map = {
      en_attente: { color: 'bg-yellow-100 text-yellow-800', label: 'En attente' },
      recu: { color: 'bg-emerald-100 text-emerald-800', label: 'Recu' },
      partiel: { color: 'bg-blue-100 text-blue-800', label: 'Partiel' },
      annule: { color: 'bg-red-100 text-red-800', label: 'Annule' },
    };
    const s = map[statut] || { color: 'bg-gray-100 text-gray-800', label: statut };
    return <Badge className={s.color}>{s.label}</Badge>;
  };

  if (loading) {
    return <div className="flex items-center justify-center py-20"><Loader2 className="h-8 w-8 animate-spin text-[#2D5A4C]" /></div>;
  }

  return (
    <div className="space-y-6 animate-fade-in">
      <div>
        <h1 className="text-2xl font-bold text-[#1A2421]" style={{ fontFamily: 'Manrope' }} data-testid="portal-payments-title">Mes paiements</h1>
        <p className="text-[#5E6D66] mt-1 text-sm">Historique de vos contributions et paiements</p>
      </div>

      <Card className="border-[#E8E6E1]">
        <CardContent className="p-0">
          {payments.length === 0 ? (
            <div className="p-12 text-center">
              <CurrencyDollar size={48} className="mx-auto text-[#E8E6E1] mb-4" />
              <p className="text-[#5E6D66]">Aucun paiement enregistre</p>
            </div>
          ) : (
            <Table>
              <TableHeader>
                <TableRow className="border-[#E8E6E1]">
                  <TableHead className="text-xs uppercase tracking-wider text-[#5E6D66]">Reference</TableHead>
                  <TableHead className="text-xs uppercase tracking-wider text-[#5E6D66]">Type</TableHead>
                  <TableHead className="text-xs uppercase tracking-wider text-[#5E6D66]">Montant attendu</TableHead>
                  <TableHead className="text-xs uppercase tracking-wider text-[#5E6D66]">Montant recu</TableHead>
                  <TableHead className="text-xs uppercase tracking-wider text-[#5E6D66]">Statut</TableHead>
                  <TableHead className="text-xs uppercase tracking-wider text-[#5E6D66]">Date</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {payments.map((p) => (
                  <TableRow key={p.id} className="border-[#E8E6E1]" data-testid={`portal-payment-row-${p.id}`}>
                    <TableCell className="text-sm font-medium text-[#1A2421]">{p.reference_interne || '-'}</TableCell>
                    <TableCell><Badge variant="outline" className="text-xs">{(p.type_flux || '').replace(/_/g, ' ')}</Badge></TableCell>
                    <TableCell className="text-sm">{(p.montant_attendu || 0).toLocaleString('fr-FR')} {p.devise || 'EUR'}</TableCell>
                    <TableCell className="text-sm font-medium text-[#2D5A4C]">{(p.montant_recu || 0).toLocaleString('fr-FR')} {p.devise || 'EUR'}</TableCell>
                    <TableCell>{getStatutBadge(p.statut)}</TableCell>
                    <TableCell className="text-xs text-[#5E6D66]">{p.created_at ? new Date(p.created_at).toLocaleDateString('fr-FR') : '-'}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
